module.exports = __webpack_public_path__ + "img/layers-half.6aaf02e4.svg";